import { MfNode } from "../node";
import { MfNodeAttr } from "../node/MfNodeAttr";

export const findAllFields = (
  node: MfNode | MfNodeAttr,
  result: MfNodeAttr[],
): void => {
  if (!node.hidden) {
    if ("validators" in node) {
      result.push(node);
    }
    node.items?.forEach((it) => findAllFields(it, result));
  }
};
